import request from "../../Utils/curl"
import Utility from "../../Utils/utility"

let ChatMessages = {
  /**
   * ChatMessage List
   */
  async ChatMessageList (context, whereFilter = null) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      if (whereFilter) {
        postData.append("filter", JSON.stringify(whereFilter))
      }

      return await request.curl(context, "message_list_console", postData, process.env.VUE_APP_MESH_API)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at message_list() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * ChatMessage View
   */
  async ChatMessageView (context, ChatMessageData) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      postData.append("this_message_id", ChatMessageData.this_message_id)
      postData.append("group_id", ChatMessageData.group_id)

      return await request.curl(context, "message_view", postData, process.env.VUE_APP_MESH_API)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at message_view() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * ChatMessage View
  */
  async ChatMessageViewConsole (context, ChatMessageData) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      postData.append("this_message_id", ChatMessageData.this_message_id)

      return await request.curl(context, "message_view_console", postData, process.env.VUE_APP_MESH_API)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at message_view_console() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * ChatMessage Add
   */
  async ChatMessageAdd (context, ChatMessageObj) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      for (let key in ChatMessageObj) {
        postData.append(key, ChatMessageObj[key])
      }

      return await request.curl(context, "message_add", postData, process.env.VUE_APP_MESH_API)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at message_add() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * ChatMessage Edit
   */
  async ChatMessageEdit (context, ChatMessageObj) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      for (let key in ChatMessageObj) {
        postData.append(key, ChatMessageObj[key])
      }
      return await request.curl(context, "message_edit", postData, process.env.VUE_APP_MESH_API)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at message_edit() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * ChatMessage Delete
   */
  async ChatMessageDelete (context, ChatMessageObj) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      for (let key in ChatMessageObj) {
        postData.append(key, ChatMessageObj[key])
      }

      return await request.curl(context, "message_delete", postData, process.env.VUE_APP_MESH_API)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.log("Exception occurred at message_delete() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * groupFiltersList
   */
  async groupFiltersList (context, filterName = "") {
    try {
      if (!filterName) {
        return
      }

      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      postData.append("filter_name", filterName)

      return await request.curl(context, "group_filter_list", postData, process.env.VUE_APP_MESH_API)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at chat_message_filter_list() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },
  /**
   * messageChannelFilterList
   */
  async messageChannelFilterList (context, filterName = "") {
    try {
      if (!filterName) {
        return
      }

      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      postData.append("filter_name", filterName)

      return await request.curl(context, "message_channel_filter_list", postData, process.env.VUE_APP_MESH_API)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at chat_message_filter_list() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  }
}

export {
  ChatMessages
}
